import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'

import type {AppThunk} from '../../../../actions/types'
import type {LoadedEndpoints} from '../../../../routes/loadEndpoint'
import type {BuildId} from '../../../../types'

import {preloadPipelineRunContent} from './PipelineRunContent/PipelineRunContent.preload'

export const preloadPipelineRunPage =
  (runId: BuildId, queryParams: QueryParams): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const {edit} = queryParams
    return [...(edit === 'true' ? [] : dispatch(preloadPipelineRunContent(runId, queryParams)))]
  }
